/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col, 
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
  
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from 'react-notification-system';
import { Addhealthcondition, getCity, getCountry } from "../../../Listfunction";
import {style} from "../../../variables/Variables";
import Select from "react-select";


class addhealthcondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      radioVariant: "1",
      healthconditionname: '',
      healthconditionnameError : null,
      countrydetails : [],
      country : [],
      countryError : null,
      show_in_app : '2',
      alert: null,
      errormessage : '',
      _notificationSystem: null,
      cardHidden: true,
      errormessages : [],
    };
    
    this.handlesubmit = this.handlesubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  handleSuccess(position){
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'success';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>Health Condition</b> - Added Successfully .
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
  }
  handleClick(position){
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'error';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>something went wrong</b>.
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
  }
  componentDidMount(){
    this.setState({_notificationSystem: this.refs.notificationSystem})
    setTimeout(
      function() {
        this.setState({ cardHidden: false }); 
      }.bind(this),
      700
    );

    var country_id = "1"
    var token = JSON.parse(localStorage.getItem('user'));
    const  obj = token.token;
    getCountry(obj).then(res =>{
      
      let pcItems = []
      res.data.map((x, i) => {
       pcItems.push({ value:x.id , label:  x.country_name })
      })
      this.setState({
        countrydetails : pcItems
      })
                
    })


}
handleNetworkError(position)
  {
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'error';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>Network Error</b>.
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
  }
  handlesubmit = (e) => {
    let error = false;
    // console.log(this.state.medicationcategoryname.length);
    this.setState({errormessages : []  });
    if(this.state.healthconditionname.length == 0)
    {error = true
       this.setState({
        healthconditionnameError: (
            <small className="text-danger">
              Health Condition is required.
            </small>
          )
        })
      }else{ this.setState({ healthconditionnameError: null });} 
      if(this.state.country.length == 0)
      {error = true
         this.setState({
          countryError: (
              <small className="text-danger">
                country is required.
              </small>
            )
          })
        }else{ this.setState({ countryError: null });} 
        
        if(!error)
        {
    var token = JSON.parse(localStorage.getItem('user'));
    const  obj = token.token
    let countryid = [];
    this.state.country.map(c=>{
      countryid.push(c.value)
    })
    
    var sia = "";
    if(this.state.show_in_app == "1")
    {
      sia = "1";
    }else if(this.state.show_in_app == "2")
    {
      sia= "0";
    }

    Addhealthcondition(this.state.healthconditionname,countryid,sia,obj)
    .then((res)=>{
      // alert('Medication data added');
       //console.log(res.data.success);
       if(res.data.success === false)
       {
          const message = res.data.data
          
          if(res.data.data.length != 0)
          {
            var ermessage = [];
            for (var key of Object.keys(res.data.data)) {
              var data = res.data.data[key]
              ermessage.push(data)
          }
          this.setState({ errormessages:  ermessage });
            this.setState({
              healthconditionnameError : <small className="text-danger">
              {message.healthconditionname }
          </small> });
          }
          else
          {
            this.handleClick('bl')
          }
       }
       else if(res.data.success === true)
       {
         this.handleSuccess('bl')
         this.setState({
           healthconditionname : '',
         
         })
        // this.props.history.push('/admin/medication-category');
       }
    })
    .catch((error) => {
      this.handleNetworkError('bl')
      console.log(error,"== error");
   });
  }
    
  }
  onChange = ((event) =>{
    const target = event.target;
      const value = target.type === 'select' ? target.selected : target.value;
      const name = target.name;
      
      this.setState({
        [name]: value
      });
   })
  
  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        
        <Grid fluid>
        <NotificationSystem ref="notificationSystem" style={style}/>

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form >
                  
                  {errormessages.length != 0 && 
                    <div className=' alert alert-danger'> 

                    {errormessages.map((data) => (
                      <React.Fragment>
                      <li>{data}</li>
                      </React.Fragment>
                    ))}
                    </div> }
                  
                    <FormGroup>
                      <ControlLabel> Health Condition</ControlLabel>
                      <FormControl name="healthconditionname" value={this.state.healthconditionname || ''} onChange={event => {
                        this.setState({ healthconditionname: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                            healthconditionnameError: (
                                <small className="text-danger">
                                  Health Condition is required.
                                </small>
                              )
                            })
                          : this.setState({ healthconditionnameError: null });
                      }} placeholder="Enter Health Condition" type="text" />
                      {this.state.healthconditionnameError}
                    </FormGroup>
                    <FormGroup>
                        <ControlLabel>Country</ControlLabel> 
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          placeholder="country"
                          name="country"
                          closeMenuOnSelect={false}
                          isMulti
                          value={this.state.country}
                          onChange={value => this.setState({
                            country : value
                          })
                          }
                          options={this.state.countrydetails}
                        />
                            
                        {this.state.countryError}       
                        </FormGroup> 
                        <FormGroup>
                        <ControlLabel>Show in App?</ControlLabel> 
                        <div className="report_feature">
                    <Radio
                            number="7"
                            option="1"
                            name="show_in_app"
                            onChange={this.onChange}
                            checked={this.state.show_in_app === "1"}
                            label="Yes"
                          /> &nbsp;
                          <Radio
                            number="8"
                            option="2"
                            name="show_in_app"
                            onChange={this.onChange}
                            checked={this.state.show_in_app === "2"}
                            label="No"
                          />
                          </div>
                    </FormGroup>
                                
                    <Button onClick={this.handlesubmit} class="btn-color"  fill>
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
            
          </Row>
        </Grid>
      </div>
    );
  }
}

export default addhealthcondition;
